import ApplePayButton from './components/ApplePayButton.vue';
import * as ApplePayApi from './api/apple-pay-api';
import { isApplePayAvailable } from './sdk/sdk-loader';

export * from './types';
export * from './token/token-storage';
export * from './validation/validator';
export * from './api/apple-pay-api';
export * from './sdk/sdk-loader';
export * from './token/token-service';

const checkIsApplePayAvailable = async (): Promise<boolean> => {
  const isFeatureEnabled = await ApplePayApi.isApplePayOneClickFeatureEnabled();
  if (!isFeatureEnabled) return false;

  return isApplePayAvailable();
};

export {
  ApplePayButton,
  checkIsApplePayAvailable,
};
